export function stripeHtml(str: string, limit: number) {
  if (str === null || str === '') return '';
  else str = str.toString();
  const res = str.replace(/(<([^>]+)>)/gi, '');
  return res.length > limit ? `${res.slice(0, limit)}...` : res;
}
